module.exports = __webpack_public_path__ + "media/music/1a064f9a752824e781ccf79ab66850ed.mp3";